import React from "react";
import styled from "styled-components";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Row, Col } from '../../components/layout';
import { FcRank, PlayerLastName, PlayerFirstName } from '../../components/text';
import { PlayerFlag } from "../../components";
import { parseHeight } from "../../lib";

// const Heading = styled.h3`
//     margin: 0;
//     padding: 0;
// `;

const PlayerCard = styled.div`
    display: flex;
    width: 100%;
    background-color: #161718;
    min-height: 83px;
    margin-top: 5px;
    position: relative;
`;

// const DragIcon = styled.span`
//     font-size: 18px;
//     font-weight: 700;
//     line-height: 22px;
// `;

const PickNumber = styled.span`
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 7px;
`;

const PlayerInfo = styled.span`
    font-size: 12px;
    line-height: 18px;
`;

const PlayerListContainer = styled(Row)`
    max-height: 1500px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 40px;
`
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

function PlayersList({players, handleRemovePlayer}){
    return players.map((player,idx) => (
        <Draggable draggableId={player.id.toString()} index={idx} key={player.id}>
        {provided => (
            <PlayerCard key={player.id} ref={provided.innerRef} {...provided.draggableProps} >
                <Col size="10%" justifyContent="center" alignItems="center" {...provided.dragHandleProps}>
                    <svg width="6px" height="10px" viewBox="0 0 6 10" version="1.1">
                        <g id="icon/drag-drop">
                            <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2ZM5 2C5.55228 2 6 1.55228 6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1C4 1.55228 4.44772 2 5 2ZM2 5C2 5.55228 1.55228 6 1 6C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4C1.55228 4 2 4.44772 2 5ZM6 5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4C5.55228 4 6 4.44772 6 5ZM1 10C1.55228 10 2 9.55228 2 9C2 8.44771 1.55228 8 1 8C0.447715 8 0 8.44771 0 9C0 9.55228 0.447715 10 1 10ZM6 9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9C4 8.44771 4.44772 8 5 8C5.55228 8 6 8.44771 6 9Z" id="Combined-Shape" fill="#D8D8D8" fillRule="evenodd" stroke="none" />
                        </g>
                    </svg>
                </Col>
                <Col size="10%" justifyContent="center" alignItems="center" flexDirection="column">
                    <PickNumber>{idx + 1}</PickNumber>
                    <FcRank>FC {player.fcRank}</FcRank>
                </Col>
                <Col size="5%"></Col>
                <Col size="65%" justifyContent="center" flexDirection="column">
                    <Row margin="0 0 4px 0" alignItems="flex-end">
                        <PlayerLastName>{player.lastName}</PlayerLastName>
                        <PlayerFirstName>{player.firstName}</PlayerFirstName>
                    </Row>
                    <Row margin="0 0 5px 0">
                        <PlayerInfo>
                            <span style={{marginRight: '3px'}}>{player.position}, {player.team}, {player.league}, {parseHeight(player.height)}, {player.weight} lbs</span>
                            <PlayerFlag player={player} width="20px" height="11px" />
                        </PlayerInfo>
                    </Row>
                </Col>
                <Col size="10%" justifyContent="center" alignItems="center">
                    <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" onClick={()=>handleRemovePlayer(player.id)}>
                        <g id="Icon/close/1px">
                            <g id="Icon/close/1px">
                            <path d="M10.5 0L0 10.5L10.5 0Z" transform="translate(0.25 0.25)" id="Path-3-Copy-4" fill="none" stroke="#D6001C" strokeWidth="2"/>
                            <path d="M10.5 10.5L0 0L10.5 10.5Z" transform="translate(0.25 0.25)" id="Path-3-Copy-5" fill="none" stroke="#D6001C" strokeWidth="2"/>
                            </g>
                        </g>
                    </svg>
                </Col>
            </PlayerCard>
        )}
        </Draggable>
    ))
}

function RankingsSummary({ rankedPlayers, setRankedPlayers, handleRemovePlayer }) {

  function onDragEnd(result) {
    if (!result.destination) {
        return;
    }

    if (result.destination.index === result.source.index) {
        return;
    }
    const players = reorder(
        rankedPlayers,
        result.source.index,
        result.destination.index
    )
    setRankedPlayers(players);
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
        {provided => (
            <PlayerListContainer ref={provided.innerRef} {...provided.droppableProps}>
                <PlayersList players={rankedPlayers} handleRemovePlayer={handleRemovePlayer}/>
                {provided.placeholder}
            </PlayerListContainer>
        )}
        </Droppable>
    </DragDropContext>
  );
}


export default RankingsSummary;